import { Component, ViewChild } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { ToolbarCammelComponent } from '../utils/toolbar-cammel/toolbar-cammel.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../utils/modal/modal.component';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { WorkbiesService } from '../services/workbies.service';
import { Cammeler, FileUser } from '../model/cammeler-dto';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { S3File } from '../model/S3_file_dto';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { STATUS_CONSTANTS } from '../utils/constants';
import { AdminModalFilesComponent } from './admin-modal-files/admin-modal-files.component';

@Component({
  selector: 'app-admin-workbies',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    ToolbarCammelComponent,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    CommonModule,
    MatChipsModule,
    MatCardModule
  ],
  templateUrl: './admin-workbies.component.html',
  styleUrl: './admin-workbies.component.scss'
})
export class AdminWorkbiesComponent {

  displayedColumns: string[] = ['identificationNumber', 'name', 'status', 'info', 'actions'];
  dataSource = new MatTableDataSource<Cammeler>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private service: WorkbiesService,
    private spinner: SpinnerVisibilityService
  ) { }

  ngOnInit(): void {
    this.getPendingWorkbies();
  }

  getPendingWorkbies() {
    this.spinnerShow();
    this.service.getWorkbies().subscribe({
      next: (response) => {
        this.dataSource.data = response.data;
        this.spinnerHide();
      },
      error: (err) => {
        this.spinnerHide();
        console.log(err);
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  openDialog(action: string, approved: boolean, uuidWorkbi: string) {
    this.dialog.open(ModalComponent, {
      width: '550px',
      disableClose: true,
      data: {
        title: 'Confirmación',
        message: '¿Esta seguro que quiere ' + action + ' al workbi?',
        actions: [
          {
            label: 'Aceptar', callback: () => {
              this.spinnerShow();
              this.service.approveWorkbi({
                uuidCammeler: uuidWorkbi,
                approved
              }).subscribe({
                next: () => {
                  this.spinnerHide();
                  this.getPendingWorkbies();
                },
                error: () => {
                  this.spinnerHide();
                }
              });
            }
          },
          { label: 'Cancelar', callback: () => { } }
        ]
      }
    });
  }

  openFileDialog(data: Cammeler) {
    const files = data.files.sort((a: any, b: any) => a.fileType.localeCompare(b.fileType));
    const dialogRef = this.dialog.open(AdminModalFilesComponent, {
      width: '1000px',
      data: {
        data: data,
        files: files
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getPendingWorkbies();
      }
    });
  }

  openDocument(fileId: string, idUser: string) {
    const body: S3File = {
      fileId,
      idUser
    };
    this.spinnerShow();
    this.service.getS3File(body).subscribe({
      next: (response) => {
        const preSignedUrl = response.data;
        window.open(preSignedUrl, '_blank');

        this.spinnerHide();
      },
      error: (err) => {
        console.log(err);
        this.spinnerHide();
      }
    })
  }

  getChipClass(status: string): string {
    switch (status) {
      case 'PENDIENTE': return 'chip-pending';
      case 'APROBADO': return 'chip-approved';
      case 'RECHAZADO': return 'chip-rejected';
      case 'EN PROCESO': return 'chip-in-process';
      default: return 'chip-default';
    }
  }

  getFileType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf': return 'application/pdf';
      case 'jpg': case 'jpeg': return 'image/jpeg';
      case 'png': return 'image/png';
      case 'txt': return 'text/plain';
      case 'doc': return 'application/msword';
      case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      default: return 'application/octet-stream';
    }
  }

  spinnerShow() {
    this.spinner.show();
  }

  spinnerHide() {
    this.spinner.hide();
  }

  disableApproveButton(cammeler: Cammeler): boolean {
    return !cammeler.isCorrectDocumentNumber ||
      !cammeler.isCorrectIssueDate ||
      !cammeler.isCorrectProfileDescription ||
      cammeler.files?.some((file: FileUser) => file.status.code !== STATUS_CONSTANTS.FILE_CORRECT_STATUS_CODE);
  }

  disableRejectButton(cammeler: Cammeler): boolean {
    return cammeler.code === 12;
  }
}
